import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function ShippingSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-5">
              {t('shippingH2')}
            </h2>
            <p className="text-foreground-700 leading-relaxed mb-6 text-base">
              {t('shippingText')}
            </p>
            <Link
              to="/cssbuy-shipping"
              className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium bg-primary-500 text-white rounded-xl hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              {t('shippingCta')}
              <i className="ri-arrow-right-line" style={{ width: 16, height: 16 }} />
            </Link>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-lg">
            <img
              src="https://readdy.ai/api/search-image?query=Shipping%20packages%20logistics%20warehouse%20boxes%20stacked%20on%20warm%20neutral%20background%20editorial%20product%20photography%20clean%20minimal%20soft%20lighting%20aesthetic&width=800&height=600&seq=shipping-img&orientation=landscape"
              alt="CSSBuy Shipping"
              className="w-full h-auto object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}